export enum PageType {
    PersonalDetails= 0,
    SignIn= 1,
    Tools= 2,
    SignUp= 3,
    ChangePassword = 4,
    OnBoarding = 5,
}